import React from 'react';
import { CustomIcon } from 'components/CustomIcon';
import Typography from 'components/Typography/Typography';
import { IntlShape } from 'react-intl';
import * as Styled from './AskProductModalAllCleared.styles';
import { definedTranslation } from '../../i18n';

interface AskProductModalAllClearedProps {
  onButtonClick: () => void;
  title?: string;
  description?: string;
  intl: IntlShape;
}

export const AskProductModalAllCleared: React.FC<
  AskProductModalAllClearedProps
> = (props) => {
  const { onButtonClick, title, description, intl } = props;

  const defaultTitles = {
    title: intl?.formatMessage(definedTranslation.allCleared.title),
    description: intl?.formatMessage(definedTranslation.allCleared.subtitle),
    button: intl?.formatMessage(definedTranslation.allCleared.button),
  };

  return (
    <Styled.AllCleared>
      <Styled.DoneIcon>
        <CustomIcon name="check" />
      </Styled.DoneIcon>
      <Typography variant="h3" component="h5" fontWeight={600}>
        {title || defaultTitles.title}
      </Typography>
      <Styled.Description variant="body" component="p">
        {description || defaultTitles.description}
      </Styled.Description>
      <Styled.CloseButton
        size="large"
        color="primary"
        variant="contained"
        onClick={onButtonClick}
        label={defaultTitles.button}
      ></Styled.CloseButton>
    </Styled.AllCleared>
  );
};
